// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1JOoN","alertIcon":"ConfirmModal_alertIcon__235U0"};